import {
  DeleteMeterLog,SaveMeterCharge, GetMeterCharge, GetMeterChargeDetail, GetMeterLog,
  GetMeterMachine, PutMeter, GetMeterOrderMachine, GetAgentMeter, GetMeterChargesByMachineId,
  PutMeterResult, GetMeterResult, GetLastMeter, MeterRegain, GetMeterQrCode, SaveMeterQrcode,
  GetMeterMachineList, GetPreMeterData, PutMeterManual, DelMeterResult
} from '@/api/meter'
export default {
  state: {

  },
  actions: {
    DeleteMeterLog({ commit }, payload) {
      return new Promise(resolve => {
        DeleteMeterLog(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SaveMeterCharge({ commit }, payload) {
      return new Promise(resolve => {
        SaveMeterCharge(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMeterCharge({ commit }, payload) {
      return new Promise(resolve => {
        GetMeterCharge(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMeterChargeDetail({ commit }, payload) {
      return new Promise(resolve => {
        GetMeterChargeDetail(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMeterLog({ commit }, payload) {
      return new Promise(resolve => {
        GetMeterLog(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMeterMachine({ commit }, payload) {
      return new Promise(resolve => {
        GetMeterMachine(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    PutMeter({ commit }, payload) {
      return new Promise(resolve => {
        PutMeter(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMeterOrderMachine({ commit }, payload) {
      return new Promise(resolve => {
        GetMeterOrderMachine(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetAgentMeter({ commit }, payload) {
      return new Promise(resolve => {
        GetAgentMeter(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMeterChargesByMachineId({ commit }, payload) {
      return new Promise(resolve => {
        GetMeterChargesByMachineId(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    PutMeterResult({ commit }, payload) {
      return new Promise(resolve => {
        PutMeterResult(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMeterResult({ commit }, payload) {
      return new Promise(resolve => {
        GetMeterResult(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetLastMeter({ commit }, payload) {
      return new Promise(resolve => {
        GetLastMeter(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    MeterRegain({ commit }, payload) {
      return new Promise(resolve => {
        MeterRegain(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMeterQrCode({ commit }, payload) {
      return new Promise(resolve => {
        GetMeterQrCode(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SaveMeterQrcode({ commit }, payload) {
      return new Promise(resolve => {
        SaveMeterQrcode(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMeterMachineList({ commit }, payload) {
      return new Promise(resolve => {
        GetMeterMachineList(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetPreMeterData({ commit }, payload) {
      return new Promise(resolve => {
        GetPreMeterData(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    PutMeterManual({ commit }, payload) {
      return new Promise(resolve => {
        PutMeterManual(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    DelMeterResult({ commit }, payload) {
      return new Promise(resolve => {
        DelMeterResult(payload).then(res => {
          resolve(res.data)
        })
      })
    },
  },
  getters: {

  },
  mutations: {

  }
}
